import { PermissionCode } from '../constants/permissions';
import { PlanTier } from '../@types/venue';
import { canUsePlanFeature } from './planGating';
import { PATH_DASHBOARD } from '../routes/paths';

/**
 * Default landing route after login, based on effective permissions + plan.
 * Mirrors RBAC plan landing rules (bar/kitchen → orders, waiter → tabs, etc.).
 */
export function getDefaultLoginPath(
  permissions: readonly string[],
  planTier: PlanTier
): string {
  const has = (code: PermissionCode) => permissions.includes(code);

  if (has('users.manage') || (has('dashboard.read') && has('orders.write'))) {
    return PATH_DASHBOARD.general.app;
  }

  if (has('orders.deliver') && has('tabs.write') && !has('menu.write')) {
    return canUsePlanFeature(planTier, 'tabs')
      ? PATH_DASHBOARD.tab.kanban
      : PATH_DASHBOARD.order.list;
  }

  if (has('orders.prepare')) {
    return PATH_DASHBOARD.order.list;
  }

  if (has('analytics.read') && !has('orders.prepare') && !has('orders.deliver')) {
    return canUsePlanFeature(planTier, 'analytics')
      ? PATH_DASHBOARD.general.analytics
      : PATH_DASHBOARD.general.app;
  }

  if (has('dashboard.read')) {
    return PATH_DASHBOARD.general.app;
  }

  if (has('tabs.read') && canUsePlanFeature(planTier, 'tabs')) {
    return PATH_DASHBOARD.tab.kanban;
  }

  if (has('orders.read')) {
    return PATH_DASHBOARD.order.list;
  }

  return PATH_DASHBOARD.permissionDenied;
}
